"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DentalMonitoringPatientLinks_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DentalMonitoringPatientLinks_Factory = /** @class */ (function () {
    function DentalMonitoringPatientLinks_Factory() {
    }
    DentalMonitoringPatientLinks_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            doctor_practices: model.doctor_practices,
            events: model.events,
            list: model.list,
            messages: model.messages,
            public_profile: model.public_profile,
            quickreplies: model.quickreplies,
            quickstarts: model.quickstarts,
            scans: model.scans,
            self: model.self,
        };
        return result;
    };
    DentalMonitoringPatientLinks_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            doctor_practices: model.doctor_practices,
            events: model.events,
            list: model.list,
            messages: model.messages,
            public_profile: model.public_profile,
            quickreplies: model.quickreplies,
            quickstarts: model.quickstarts,
            scans: model.scans,
            self: model.self,
        };
        return result;
    };
    return DentalMonitoringPatientLinks_Factory;
}());
exports.DentalMonitoringPatientLinks_Factory = DentalMonitoringPatientLinks_Factory;
